import {Component, inject, input, InputSignal, model, ModelSignal, output, OutputEmitterRef, ViewEncapsulation} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DxListModule, DxPopupModule} from 'devextreme-angular';
import {SharedModule} from "../../../../../../shared/shared.module";
import {ButtonThemeEnum} from "../../../../../../shared/ui/button/button-theme-enum";
import {PointDeLivraisonDTO} from '../../../../../../core/dtos/point-de-livraison-d-t-o';
import {ContratMenuConviveDTO} from '../../../../../../core/dtos/contratmenuconvive-dto';
import {PointDeLivraisonService} from '../../../../../../core/services/entities/point-de-livraison.service';
import {UtilsService} from '../../../../../../core/utils/utils.service';
import {ToastService} from '../../../../../../core/services/technique/toast.service';
import {MSG_KEY, MSG_SEVERITY} from '../../../../../../core/constants';
import {cloneDeep as _cloneDeep} from 'lodash';

@Component({
  selector: 'yo-dialog-ajout-plc',
  templateUrl: './dialog-ajout-plc.component.html',
  styleUrls: ['./dialog-ajout-plc.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, DxPopupModule, DxListModule, SharedModule],
  encapsulation: ViewEncapsulation.None
})
export class DialogAjoutPlcComponent {

  displayAddDialog: ModelSignal<boolean> = model<boolean>(false);
  plcList: InputSignal<PointDeLivraisonDTO[]> = input<PointDeLivraisonDTO[]>([]);
  plcToAddList: InputSignal<PointDeLivraisonDTO[]> = input<PointDeLivraisonDTO[]>([]);
  contratMenuConvive: InputSignal<ContratMenuConviveDTO | undefined> = input<ContratMenuConviveDTO>();

  plcListChange: OutputEmitterRef<PointDeLivraisonDTO[]> = output<PointDeLivraisonDTO[]>();

  protected readonly ButtonThemeEnum = ButtonThemeEnum;

  selectedPlcToAddList: PointDeLivraisonDTO[] = [];

  #pdlSvc = inject(PointDeLivraisonService);
  #utils = inject(UtilsService);
  #toastSvc = inject(ToastService);

  closeDialog(): void {
    this.selectedPlcToAddList = [];
    this.displayAddDialog.set(false);
  }

  attachSelectedPlc(): void {
    if (this.#utils.isNullOrEmpty(this.contratMenuConvive()) || this.#utils.isCollectionNullOrEmpty(this.selectedPlcToAddList)) {
      return;
    }

    this.#pdlSvc.attachToPrestation(this.contratMenuConvive(), this.selectedPlcToAddList).subscribe(response => {
      if (!this.#utils.isResponseSupplierError(response)) {
        this.plcListChange.emit(this.#buildUpdatedPlcList(this.plcList(), this.selectedPlcToAddList));
        this.#toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS,
          `Points de livraison ajoutés à la prestation "${this.contratMenuConvive().libelle}".`);
        this.closeDialog();
      }
    });
  }

  #buildUpdatedPlcList(currentList: PointDeLivraisonDTO[], toAdd: PointDeLivraisonDTO[]): PointDeLivraisonDTO[] {
    return _cloneDeep(
      [...currentList, ...toAdd]
        .filter((plc, idx, arr) => arr.findIndex(item => item.id === plc.id) === idx)
        .sort((a, b) => a.libelle.localeCompare(b.libelle))
    );
  }
}
